// extracted by mini-css-extract-plugin
export default {"linkedUserWrapper":"index_linkedUserWrapper__Ke9dk"};